import React from 'react'
import { observer } from 'mobx-react'

import NoChartData from './NoChartData'
import './derived.scss'

const LMXChartSlot = ({ store, position, chartKey }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)
    const data = store.getChartDataForQuestion(`${question.surveyId}-LMX`, position)

    return (
        <div style={{ width: '100%', height: '100%' }}>
            {question
                ? store.getChart(
                    {
                        ...data,
                        title: '',
                        containerSize: { height: 400, width: 450 },
                        chartType: 'lmx',
                        kpiType: 'LMX',
                        surveyId: question.surveyId,
                        surveyDefaultLocale: question.surveyDefaultLocale || data?.surveyDefaultLocale,
                        settings: question.settings,
                        key: chartKey,
                    },
                    data?.data,
                    [...question.comparisonYears, question.year],
                ) || <NoChartData question={question} />
                : null}
        </div>
    )
}

export default observer(LMXChartSlot)
